import { Component, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SignatureInfo, StepInfo } from 'services/pdf-template/pdf-template.interface';
import { SmartForm } from '@certemy/ui-components';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';

const SIG_TYPE = [{ name: 'Professional', id: 1 }, { name: 'Supervisor', id: 2 }];

const SIG_TYPE_WITH_SECONDARY = [
  { name: 'Professional', id: 1 },
  { name: 'Supervisor', id: 2 },
  { name: 'Secondary Supervisor', id: 3 },
];

@Component({
  selector: '[pdf-template-signature-assign]',
  templateUrl: './pdf-template-signature-assign.component.html',
  styleUrls: ['./pdf-template-signature-assign.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PdfTemplateSignatureAssignComponent),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PdfTemplateSignatureAssignComponent,
    },
  ],
})
export class PdfTemplateSignatureAssignComponent implements OnInit, OnDestroy, ControlValueAccessor, Validator {
  form: UntypedFormGroup;

  value: SignatureInfo = null;

  @Input() public steps: StepInfo[];

  @Input() public name: string;

  @Input() public allowSecondarySupervisor?: boolean;

  constructor() {}

  ngOnInit() {
    this.form = new UntypedFormGroup({
      signatureType: new UntypedFormControl(null, Validators.compose([Validators.required])),
      stepId: new UntypedFormControl(null, Validators.compose([Validators.required])),
    });
  }

  ngOnDestroy() {
    for (let sub of this.onChangeSubs) {
      sub.unsubscribe();
    }
  }

  onTouched: Function = () => {};

  onChangeSubs: Subscription[] = [];

  get signatureType(): SmartForm.FieldOption[] {
    return this.allowSecondarySupervisor ? SIG_TYPE_WITH_SECONDARY : SIG_TYPE;
  }

  get stepsList(): SmartForm.FieldOption[] {
    return this.steps.map(item => {
      return {
        name: item.name,
        id: item.stepId,
      };
    });
  }

  writeValue(signatureInfo: SignatureInfo) {
    this.value = signatureInfo;

    if (signatureInfo) {
      this.form.get('signatureType').setValue(signatureInfo.signatureType);
      this.form.get('stepId').setValue(signatureInfo.stepId);
    }
  }

  registerOnChange(onChange: any) {
    const sub = this.form.valueChanges.subscribe(onChange);
    this.onChangeSubs.push(sub);
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  validate(control: AbstractControl) {
    if (this.form.valid) {
      return null;
    }

    let errors: any = {};

    errors = this.addControlErrors(errors, 'signatureType');
    errors = this.addControlErrors(errors, 'stepId');

    return errors;
  }

  addControlErrors(allErrors: any, controlName: string) {
    const errors = { ...allErrors };

    const controlErrors = this.form.controls[controlName].errors;

    if (controlErrors) {
      errors[controlName] = controlErrors;
    }

    return errors;
  }
}
